export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.b03f58b0.jpg";